import "./BookingFlowLayout.css";

function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `₹${n.toLocaleString("en-IN")}`;
}

/**
 * Right-rail booking summary used on PRV + summary steps (mockup layout).
 */
export function BookingFlowSidebar({
  caregiverName,
  caregiverFeeLabel,
  patientName,
  patientMeta,
  subscriptionLabel,
  subscriptionActive,
  subscriptionUntil,
  verificationLabel = "Not selected",
  totalLabel,
  totalHint,
  secureNote = true,
}) {
  return (
    <aside className="bfl-sidebar" aria-label="Booking summary">
      <h3 className="bfl-sidebar__title">Booking Summary</h3>

      <div className="bfl-sidebar__block">
        <p className="bfl-sidebar__label">Caregiver</p>
        <p className="bfl-sidebar__value">{caregiverName || "—"}</p>
        {caregiverFeeLabel ? <p className="bfl-sidebar__meta">{caregiverFeeLabel}</p> : null}
      </div>

      <div className="bfl-sidebar__block">
        <p className="bfl-sidebar__label">Patient</p>
        <p className="bfl-sidebar__value">{patientName || "—"}</p>
        {patientMeta ? <p className="bfl-sidebar__meta">{patientMeta}</p> : null}
      </div>

      <div className="bfl-sidebar__block">
        <p className="bfl-sidebar__label">Subscription</p>
        <p className="bfl-sidebar__value bfl-sidebar__value--row">
          <span>{subscriptionLabel || "Service plan"}</span>
          <span className={`bfl-pill${subscriptionActive ? " is-ok" : " is-warn"}`}>
            {subscriptionActive ? "Active" : "Inactive"}
          </span>
        </p>
        {subscriptionUntil ? (
          <p className="bfl-sidebar__meta">Valid till {subscriptionUntil}</p>
        ) : null}
      </div>

      <div className="bfl-sidebar__block">
        <p className="bfl-sidebar__label">Verification</p>
        <p className="bfl-sidebar__value">{verificationLabel}</p>
      </div>

      <div className="bfl-sidebar__total">
        <p className="bfl-sidebar__label">Total (Estimated)</p>
        <p className="bfl-sidebar__total-value">{totalLabel}</p>
        {totalHint ? <p className="bfl-sidebar__meta">{totalHint}</p> : null}
      </div>

      {secureNote ? (
        <p className="bfl-sidebar__secure">
          <span aria-hidden="true">🔒</span> Secure payment
        </p>
      ) : null}
    </aside>
  );
}

export function BookingFlowSplit({ children, sidebar }) {
  return (
    <div className="bfl-split">
      <div className="bfl-split__main">{children}</div>
      <div className="bfl-split__rail">{sidebar}</div>
    </div>
  );
}

export function formatInr(value) {
  return formatMoney(value);
}
